import React, { FunctionComponent, Fragment, useContext } from "react";
import { Theme, makeStyles } from "@material-ui/core";
import { LOGIN_FORM_TYPE } from "../../models/login-form-type";
import { animated } from "react-spring";
import { LoginForm } from "./login-form";
import { RegisterForm } from "./register-form";
import { LOGIN_SECTION_HEIGHT, MOBILE_REGISTER_SECTION_HEIGHT } from "./login-card";
import { LoginContext } from "./context/login-context";
import { CodeForm } from "./code-form";
import { PasswordForgottenForm } from "./password-forgotten-form";
import { PasswordChangeForm } from "./password-change-form";

interface ILoginFormSectionStyleProps {
  formType: LOGIN_FORM_TYPE;
}

const useStyles = makeStyles((theme: Theme) => ({
  textFieldCard: {
    position: "relative",
    overflow: "visible",
    width: "100%",
  },
  textFieldCardWrapper: {
    position: "absolute",
    width: "100%",
    minHeight: LOGIN_SECTION_HEIGHT,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.50s ease-out",
    opacity: 0,
    visibility: "hidden",
    [theme.breakpoints.down("xs")]: {
      minHeight: ({ formType }: ILoginFormSectionStyleProps) =>
        formType === LOGIN_FORM_TYPE.REGISTER ? MOBILE_REGISTER_SECTION_HEIGHT : LOGIN_SECTION_HEIGHT,
    },
  },
  activeForm: {
    opacity: 1,
    visibility: "visible",
  },
}));

interface ILoginFormSectionProps {}

const forms = {
  [LOGIN_FORM_TYPE.LOGIN]: LoginForm,
  [LOGIN_FORM_TYPE.REGISTER]: RegisterForm,
  [LOGIN_FORM_TYPE.CODE]: CodeForm,
  [LOGIN_FORM_TYPE.PASSWORD_FORGOTTEN]: PasswordForgottenForm,
  [LOGIN_FORM_TYPE.CHANGE_PASSWORD]: PasswordChangeForm,
};

export const LoginFormSection: FunctionComponent<ILoginFormSectionProps> = (props) => {
  const { formType, shakeAnimationStyle } = useContext(LoginContext);
  const classes = useStyles({ formType });
  return (
    <Fragment>
      {Object.entries(forms).map(([key, form], index) => {
        const activeClass = key === formType ? classes.activeForm : "";
        const Form = form;
        return (
          <animated.div key={index}>
            <animated.div style={shakeAnimationStyle}>
              <div className={`${classes.textFieldCardWrapper} ${activeClass}`}>
                <div className={classes.textFieldCard}>
                  <Form />
                </div>
              </div>
            </animated.div>
          </animated.div>
        );
      })}
    </Fragment>
  );
};
